import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a02c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder", "multiline", "integer"]

import { ref, watch, onMounted, PropType } from 'vue';

// Defining props using defineProps with type annotations

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentEditable',
  props: {
  content: {type: [String, Number] as PropType<string | number>, default: ''},
  placeholder: {type: String as PropType<string>, default: ''},
  multiline: {type: Boolean as PropType<boolean>, default: false},
  integer: {type: Boolean as PropType<boolean>, default: false},
  decimal: {type: Boolean as PropType<boolean>, default: false},
},
  emits: ['update', 'insert', 'delete'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const contentEditableRef = ref(null);

onMounted(async () => {
  if (contentEditableRef.value) {
    contentEditableRef.value.innerText = props.content;
  }
});

watch(() => props.content, (newValue) => {
  if (contentEditableRef.value) {
    contentEditableRef.value.innerText = newValue;
  }
});

const onBlur = (event: Event) => {
  const target = event.target as HTMLElement;
  if (target.innerText.length > 0 && target.innerText != '\n') {
    emit("update", target.innerText);
  }
};

const onEnter = (event: KeyboardEvent) => {
  if (!props.multiline) {
    event.preventDefault();
    emit("insert", event);
  }
};

const onDelete = (event: KeyboardEvent) => {
  if (!props.multiline && contentEditableRef.value && (contentEditableRef.value.innerText.length === 0 || contentEditableRef.value.innerText === '\n')) {
    event.preventDefault();
    emit("delete", event);
  }
};

const onKeyPress = (event: KeyboardEvent) => {
  if (props.decimal) {
    if (isNaN(Number(event.key)) && event.key !== "." && event.key !== "Backspace") {
      event.preventDefault();
    }
  } else if (props.integer) {
    if (isNaN(Number(event.key)) && event.key !== "Backspace") {
      event.preventDefault();
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "contentEditableRef",
    ref: contentEditableRef,
    contenteditable: "true",
    placeholder: __props.placeholder,
    multiline: __props.multiline,
    integer: __props.integer,
    onBlur: onBlur,
    onKeypress: _withKeys(onEnter, ["enter"]),
    onKeyup: _withKeys(onDelete, ["delete"]),
    onKeydown: onKeyPress
  }, null, 40, _hoisted_1))
}
}

})